import React, { useCallback } from "react";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTypedFlags } from "../../../hooks/useTypedFlags";
import {
    useSettings,
    WorkspaceSettingsPages,
} from "../../settings/SettingsProvider";
import { useCanManageBilling } from "../../../hooks/useCanManageBilling";

export const WorkspaceItems: React.FC = () => {
    const { open: openSettings } = useSettings();
    const canManageBilling = useCanManageBilling();
    const navigate = useNavigate();

    const { directory: canUseDirectory, locks: canUseLocks } = useTypedFlags();
    const handleSelectedNav = useCallback(
        (path: string) => {
            navigate(path);
        },
        [navigate],
    );

    return (
        <>
            <Dropdown.Header>Workspace</Dropdown.Header>
            <Dropdown.Item
                onClick={() => openSettings([WorkspaceSettingsPages.MEMBERS])}
            >
                Members
            </Dropdown.Item>

            {canUseDirectory && (
                <Dropdown.Item
                    onClick={() =>
                        openSettings([WorkspaceSettingsPages.DIRECTORY])
                    }
                >
                    Directory
                </Dropdown.Item>
            )}

            {canUseLocks && (
                <Dropdown.Item onClick={() => handleSelectedNav("/locks")}>
                    Locks
                </Dropdown.Item>
            )}

            {canManageBilling && (
                <>
                    <Dropdown.Item onClick={() => openSettings(["plans"])}>
                        Plans
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => openSettings(["billing"])}>
                        Billing
                    </Dropdown.Item>
                </>
            )}
        </>
    );
};
